
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ProviderData, SubService, Employee } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-provider-details',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatSelectModule, ReactiveFormsModule],
  templateUrl: './provider-details.component.html'
})
export class ProviderDetailsComponent {
  @Input() formGroup!: FormGroup;
  @Input() providerData?: ProviderData;
  @Input() subServices: SubService[] = [];
  @Input() showReviewStatus: boolean = false;
  @Input() getTherapyEmployeeLength!: (employees: Employee[]) => number;
  @Input() getTutoringEmployeeLength!: (employees: Employee[]) => number;

  employeesDisplay(): string {
    if (this.providerData?.type === 'Transportation') {
      const count =
        this.providerData.employees?.filter((employee) => {
          const type = String(employee.employeeType ?? '').toLowerCase();
          return type === 'transportation';
        }).length ?? 0;
      return `Transportation (${count})`;
    }
    return (
      'Therapy (' +
      this.getTherapyEmployeeLength(this.providerData?.employees || []) +
      '), Tutoring (' +
      this.getTutoringEmployeeLength(this.providerData?.employees || []) +
      ')'
    );
  }
}
